import { Text } from '@hg/stylizator/typography'
import * as React from 'react'
import styled from 'styled-components'

interface IProps {
  isActive?: boolean
}

type TStyledProps = React.ComponentProps<typeof Background>

const Pill: React.FC<React.PropsWithChildren<IProps & TStyledProps>> = ({ isActive, children, ...props }) => (
  <Background {...props} data-active={isActive}>
    <Text type="body_small" color="currentColor">
      <span>{children}</span>
    </Text>
  </Background>
)

export default Pill

const Background = styled.a`
  display: inline-block;
  cursor: pointer;
  box-sizing: border-box;
  padding: 4px 8px;
  background: ${(props) => props.theme.color.blue[10]};
  border: 1px solid ${(props) => props.theme.color.blue[20]};
  border-radius: 4px;
  color: ${(props) => props.theme.color.blue[50]};

  &:hover,
  &[data-active='true'] {
    background: ${(props) => props.theme.color.blue[60]};
    border-color: ${(props) => props.theme.color.blue[60]};
    color: ${(props) => props.theme.color.white};
  }
`
